module.exports = __webpack_public_path__ + "img/0S6A0259.ef38ca28.jpg";